<template>
<div>
  <div class="dashboard-window dashboard-functions">
    <div :class="{hidden: isInSettings}" id="active" ref="arrow">
      <div class="arrow"></div>
    </div>
    <router-link to="/promotions">
      <div ref="promotions" class="module" :class="{grayed: isInSettings}"
          @click="() => highlightItem('promotions')">
        <div class="module-icon">
          <PromotionsIcon/>
        </div>
        <div class="module-title">
          <h3>Promocje</h3>
        </div>
      </div>
    </router-link>
    <router-link to="/comments">
      <div ref="comments" class="module" :class="{grayed: isInSettings}"
          @click="() => highlightItem('comments')">
        <div class="module-icon">
          <CommentsIcon />
        </div>
        <div class="module-title">
          <h3>Komentarze</h3>
        </div>
      </div>
    </router-link>
    <router-link to="/statistics">
      <div ref="statistics" class="module" :class="{grayed: isInSettings}"
          @click="() => highlightItem('statistics')">
        <div class="module-icon">
          <StatisticsIcon />
        </div>
        <div class="module-title">
          <h3>Statystyki</h3>
        </div>
      </div>
    </router-link>
  </div>
</div>
</template>

<script>
import PromotionsIcon from '@/components/svgs/icons/PromotionsIcon.vue';
import CommentsIcon from '@/components/svgs/icons/CommentsIcon.vue';
import StatisticsIcon from '@/components/svgs/icons/StatisticsIcon.vue';

const isDesktop = () => (Math.max(
  document.documentElement.clientWidth, window.innerWidth
) || 0) > 768;

export default {
  name: "ModuleMenu",
  data() {
    return {
      isInSettings: false
    };
  },
  components: {
    PromotionsIcon,
    CommentsIcon,
    StatisticsIcon
  },
  methods: {
    highlightItem(id) {
      const axis = isDesktop() ? "Y" : "X";
      const { arrow } = this.$refs;
      const activeModule = this.$refs[id];
      const modules = Object.values(this.$refs).filter(x => x !== arrow);

      // Make every module grayed out by default
      let index = 0;
      for (let i = 0; i < modules.length; i += 1) {
        if (modules[i] === activeModule) index = i;
        modules[i].style.color = "#707070";
        modules[i].style.fill = "#707070";
      }

      // Move the arrow to the desired location
      arrow.style.transform = `translate${axis}(${index * 75}px)`;

      // Make the text white
      activeModule.style.color = '#fff';
      activeModule.style.fill = '#fff';

      // Add border radius to the first and last label
      // NOTE: overflow: hidden; wouldn't work because we
      // want to display the arrow above the main view
      if (arrow.style.transform === `translate${axis}(0px)`) {
        arrow.style.borderRadius = isDesktop() ? "10px 10px 0 0" : "10px 0 0 10px";
      } else if (arrow.style.transform === `translate${axis}(${(modules.length - 1) * 75}px)`
        && isDesktop()) {
        arrow.style.borderRadius = "0 0 10px 10px";
      } else arrow.style.borderRadius = "0";
    }
  },
  watch: {
    $route() {
      this.isInSettings = window.location.pathname === '/profile';
    }
  },
  mounted() {
    this.isInSettings = window.location.pathname === '/profile';
    const url = window.location.pathname.substring(1);
    if (url !== 'profile') {
      this.highlightItem(url);
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}

.dashboard-functions {
  margin-top: 5px;
  border-radius: 10px;
  position: relative;
  background: #2a2a2a;

  @media(max-width: 768px) {
    top: 7px;
    height: 60px;
    display: block;
    justify-content: space-between;
  }
}

#active {
  position: absolute;
  display: block;
  width: 100%;
  height: 75px;
  top: 0;
  background: linear-gradient(
    135deg,
    rgb(54, 112, 206) 0%,
    rgb(86, 204, 192) 90%
  );
  transition: transform 0.5s, border-radius 0.5s, opacity 0.25s;

  &.hidden {
    opacity: 0;
  }

  @media (max-width: 768px) {
    background: linear-gradient(
      160deg,
      rgb(54, 112, 206) 0%,
      rgb(86, 204, 192) 70%
    );
    width: 75px;
    height: 65px;
  }
}

.arrow {
  content: "";
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 10px 0 10px 10px;
  border-color: transparent transparent transparent rgb(86, 204, 192);
  position: absolute;
  top: 30px;
  overflow: visible;
  left: 100%;

  @media (max-width: 768px) {
    content: "";
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 16px 18px 0 18px;
    border-color: rgb(86, 204, 192) transparent transparent transparent;
    position: absolute;
    top: 90%;
    left: 25%;
  }
}

.module {
  position: relative;
  height: 75px;
  border-top: 1px solid #707070;
  fill: #707070;
  color: #707070;
  transition: color 0.5s, fill 0.5s;
  font-size: 20px;

  &.grayed {
    .module-icon {
      fill: #707070;
    }
    .module-title {
      color: #707070;
    }
  }

  &:hover {
    cursor: pointer;
  }

  @media(max-width: 768px) {
    width: 75px;
    float: left;
    text-align: left;
    border: none;
  }
}

a:first-of-type .module {
  border-top: none;
}

#promotions {
  border-radius: 10px 10px 0 0;
  border-top: none;
}

.module-icon {
  margin: 18px;
  width: 32px;
  float: left;
  left: 5px;

  @media (max-width: 768px) {
    width: 100%;
    padding: 15px 20px;
    margin: 0;
    left: 0;
  }
}

.module-title {
  & > h3 {
    font-weight: bolder;
  }
  display: inline-block;

  @media (max-width: 768px) {
    display: none;
  }
}
</style>
